import UserCard from './UserCard';
import DiagramCard from './DiagramCard';
import SettingsCard from './SettingsCard';
import UserSettingsCard from './UserSettingsCard';
import { dashboardPermissionCheck } from '../store/dashboardActions';
import { useAuthStore } from '../../auth/authStore';
import { useOrgUserStore } from '../../../shared/organization/orgUserStore';
import { Button } from '../../../components/Form/Button';
import { handleLogout } from '../../auth/authActions';

const DashboardLayout = () => {
  const auth = useAuthStore((state) => state.auth);
  const orgMembers = useOrgUserStore((state) => state.items);

  if (!auth?.uid) {
    return null;
  }

  const canEdit = dashboardPermissionCheck('admin', auth?.uid, orgMembers);

  return (
    <div className="bg-gray-50 w-full h-full">
      <div className="container mx-auto sm:px-6 lg:px-8 pt-6">
        <div className="my-6 flex items-center justify-between">
          <h1 className="text-2xl font-bold">Dashboard</h1>
          <Button
            variant="outline"
            type="button"
            className="flex items-center gap-2"
            onClick={handleLogout}
          >
            Logout
          </Button>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 auto-rows-max">
          <DiagramCard />
          <UserCard />
          <UserSettingsCard />
          {canEdit && <SettingsCard />}
        </div>
      </div>
    </div>
  );
};
export default DashboardLayout;
